module.exports = __webpack_public_path__ + "img/main.e934f662.webp";